import { saveAs } from 'file-saver'
import axios from 'axios'
import store from '@/store'
import { baseURL } from '@/config/net.config'
import { Loading, Message } from 'element-ui'
import router from '@/router'
import {
  loadingText,
  messageDuration,
  messageName,
  authMode,
  authUrl,
  publicPath,
} from '@/config'
let orderApiPre = '/works-partner/v1'
import _ from 'lodash'
let $baseMessage = (
  message,
  type = 'info',
  dangerouslyUseHTMLString = false
) => {
  Message({
    message,
    type,
    customClass: 'change' + type,
    duration: messageDuration,
    dangerouslyUseHTMLString,
    showClose: true,
  })
}

export default {
  name(name, isDelete = true) {
    const token = store.getters['user/token']
    var url =
      baseURL +
      '/common/download?fileName=' +
      encodeURI(name) +
      '&delete=' +
      isDelete
    axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: { Authorization: 'Bearer ' + token },
    }).then(async (res) => {
      const isLogin = await this.blobValidate(res.data)
      if (isLogin) {
        const blob = new Blob([res.data])
        this.saveAs(blob, decodeURI(res.headers['download-filename']))
      } else {
        Message.error(
          'セッションが無効であるか、セッションの有効期限が切れています。再度ログインしてください。'
        )
      }
    })
  },

  requestMethod(resource, data, download) {
    const loadingInstance = Loading.service({
      lock: true,
      loadingText,
      spinner: 'dots-loader',
      background: 'hsla(0,0%,100%,.8)',
    })

    const token = store.getters['user/token']
    var url = baseURL + encodeURI(resource)
    if (!data) {
      axios({
        method: 'get',
        url: url,
        responseType: 'blob',
        headers: { Authorization: 'Bearer ' + token },
      })
        .then(
          async (res) => {
            download(res)

            loadingInstance.close()
          },
          (error) => {
            if (error.message.includes('code 400')) {
              let content = error.response.data
              let resBlob = new Blob([content])
              let reader = new FileReader()
              reader.readAsText(resBlob, 'utf-8')
              reader.onload = () => {
                let messageObj = JSON.parse(reader.result)
                let errMsg = ''
                let errs = []
                if (_.has(messageObj, messageName) && messageObj[messageName]) {
                  messageObj[messageName].map((item) => errs.push(item.message))
                }
                if (errs.length > 0) {
                  errMsg = errs.join('¥r¥n')
                }
                $baseMessage(errMsg, 'error')
              }
              loadingInstance.close()
            } else {
              this.redirect()
            }
          }
        )
        .catch(() => {
          this.redirect()
        })
    } else {
      axios({
        method: 'post',
        url: url,
        data,
        responseType: 'blob',
        headers: { Authorization: 'Bearer ' + token },
      })
        .then(
          async (res) => {
            download(res)
            loadingInstance.close()
          },
          (error) => {
            if (error.message.includes('code 400')) {
              let content = error.response.data
              let resBlob = new Blob([content])
              let reader = new FileReader()
              reader.readAsText(resBlob, 'utf-8')
              reader.onload = () => {
                let messageObj = JSON.parse(reader.result)
                let errMsg = ''
                let errs = []
                if (_.has(messageObj, messageName) && messageObj[messageName]) {
                  messageObj[messageName].map((item) => errs.push(item.message))
                }
                if (errs.length > 0) {
                  errMsg = errs.join('¥r¥n')
                }
                $baseMessage(errMsg, 'error')
              }
              loadingInstance.close()
            } else {
              this.redirect()
            }
          }
        )
        .catch(() => {
          this.redirect()
        })
    }
  },
  redirect() {
    if (authMode != 'normal') {
      window.location.href = `${authUrl}${publicPath}works-partner/oauth2/authorization/tomooni`
    } else {
      store
        .dispatch('user/resetAll')
        .then(() =>
          router.push({ path: '/login', replace: true }).then(() => {})
        )
    }
  },
  resource(resource, data, pre = orderApiPre) {
    let that = this
    function download(res) {
      const blob = new Blob([res.data], { type: 'application/octet-stream' })
      that.saveAs(
        blob,
        decodeURI(res.headers['filename']).replace(RegExp('%23', 'g'), '#')
      )
    }
    this.requestMethod(resource, data, download, pre)
  },

  //zip
  zip(resource, data, pre = orderApiPre) {
    let that = this
    function download(res) {
      const blob = new Blob([res.data], { type: 'application/zip' })
      that.saveAs(
        blob,
        decodeURI(res.headers['filename']).replace(RegExp('%23', 'g'), '#')
      )
    }
    this.requestMethod(resource, data, download, pre)
  },
  saveAs(text, name, opts) {
    saveAs(text, name, opts)
  },
  async blobValidate(data) {
    try {
      const text = await data.text()
      JSON.parse(text)
      return false
    } catch (error) {
      return true
    }
  },
}
